<template>
    <div class="house-status-default">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <task-menu :isOpen="taskMenu" :taskHouseInfo="taskHouseInfo" @taskClose="closeTaskMenu"></task-menu>
        <modal class="todo-list" :display="todoList" @modalStatus="closeModal('todoList')" >
            <todo-list></todo-list>
        </modal>
        <modal class="new-contract" :display="newContract" @modalStatus="closeModal('newContract')" >
            <h1>請問您要新增哪種合約？</h1>
            <div class="content">
                <contract-type @getLink="contractLink"></contract-type>
            </div>
            <div class="btn-group">
                <router-link :to="{ name: newContractLink}">
                    <button class="default-button" @click="closeModal('newContract')">確認</button>
                </router-link>
                <button class="border-button" @click="closeModal('newContract')">取消</button>
            </div>
        </modal>
        <new-all-bill></new-all-bill>
        <div class="amount-bar">
            <block-amount></block-amount>
        </div>
        <div class="house-status-default-wrap">
            <div class="house-status-default-wrap-left">
                <div class="house-status-default-wrap-left-head">
                    <span class="title">房態首頁</span>
                    <div class="group-right">
                        <!-- <drop-menu refName="kk" dropMenuMsg="管理"  border="1px solid #ff9275" bgColor="#fff" arrowColor="green">
                            <ul>
                                <router-link :to="{ name: 'housemgt'}">
                                    <li data-id="1">
                                        <img src="@/assets/img/icon/house_management_gray.svg" alt="">
                                        房源管理
                                    </li>
                                </router-link>
                                <router-link :to="{ name: 'bookingmgt'}">
                                    <li data-id="2">
                                        <img src="@/assets/img/icon/bill_management_gray.svg" alt="">
                                        帳單列表
                                    </li>
                                </router-link>
                                <router-link :to="{ name: 'bookingmgt'}">
                                    <li data-id="3">
                                        <img src="@/assets/img/icon/order_management_gray.svg" alt="">
                                        預定管理
                                    </li>
                                </router-link>
                                <router-link :to="{ name: 'bookingmgt'}">
                                    <li data-id="4">
                                        <img src="@/assets/img/icon/task_management_gray.svg" alt="">
                                        委託房客
                                    </li>
                                </router-link>
                            </ul>
                        </drop-menu> -->
                        <drop-menu refName="kk" dropMenuMsg="更多功能" border="1px solid #ff9275" bgColor="#ff9275" arrowColor="white">
                            <ul>
                                <router-link :to="{ name: 'batchUpload'}">
                                    <li data-id="1">
                                        <img src="@/assets/img/icon/plus_gray.svg" alt="">
                                        批次新增房源
                                    </li>
                                </router-link>
                                <router-link :to="{ name: 'addhouse'}">
                                    <li data-id="2">
                                        <img src="@/assets/img/icon/plus_gray.svg" alt="">
                                        刊登廣告
                                    </li>
                                </router-link>
                                <!-- <li data-id="3" @click="newContract = true">
                                    <img src="@/assets/img/icon/plus_gray.svg" alt="">
                                    新增紙本合約
                                </li> -->
                                <!-- <li data-id="4" @click="newAllBill()">
                                    <img src="@/assets/img/icon/plus_gray.svg" alt="">
                                    新增帳單費用
                                </li> -->
                                <li data-id="5">
                                    <router-link  :to="{ name: 'NewTask'}">
                                        <img src="@/assets/img/icon/plus_gray.svg" alt="">
                                        新增委託
                                    </router-link>
                                </li>
                                <!-- <li data-id="6">
                                    <router-link :to="{ name: 'addhouse'}">
                                        <img src="@/assets/img/icon/plus_gray.svg" alt="">
                                        記帳
                                    </router-link>
                                </li> -->
                            </ul>
                        </drop-menu>
                    </div>
                </div>
                <district-house v-for="(houseItem, index) in fileterByDistrict" :key="index" :county="houseItem.county" :total="houseItem.total" :district="houseItem.district" :house="houseItem.houseList" @getHouseInfo="getHouse"></district-house>
                <transition name="fade"> 
                    <district-house v-if="houseIsLoading"></district-house>
                </transition>
                <transition name="fade"> 
                    <district-house v-if="houseIsLoading"></district-house>
                </transition>
                <transition name="fade"> 
                    <district-house v-if="houseIsLoading"></district-house>
                </transition>
                <district-house v-if="houseResult.length == 0 && !houseIsLoading" :noHouse="true"></district-house>
            </div>
            <div class="house-status-default-wrap-right">
                <div class="house-status-default-filter" :class="{'fixed': filterIsFixed}">
                    <div class="house-status-default-filter-title">
                        <span>
                            <img src="@/assets/img/icon/filter_gray.svg" alt="">
                            篩選
                        </span>
                        <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                            清除篩選
                        </span>
                        
                    </div>
                    <div class="house-status-default-filter-todo-list">
                        <!-- <div class="todo-button" @click="todoList = true">
                            待辦清單
                        </div> -->
                        <div class="todo-state">
                            <span class="title">空房</span>
                            <div class="todo-state-wrap">
                                <div class="todo-state-wrap-empty">
                                    <div class="check-box-wrap">
                                        <rent-checkbox ref="empty" v-model="filter.status" val="0" checkboxMsg="空房待租" tickColor="black" bgColor="#fff" borderColor="#d5dad8"  :setDefault="isDefault"></rent-checkbox>
                                        <span>{{statusCount(0)}}</span>
                                    </div>
                                    <div class="check-box-wrap">
                                        <rent-checkbox  ref="beSigned" v-model="filter.status" val="1" checkboxMsg="房客預定" tickColor="white" bgColor="#71aae5" borderColor="#71aae5"   :setDefault="isDefault"></rent-checkbox>
                                        <span>{{statusCount(1)}}</span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="house-status-default-filter-todo-list">
                        <div class="todo-state">
                            <span class="title">已租</span>
                            <div class="todo-state-wrap">
                                <div class="todo-state-wrap-rented">
                                    <div class="check-box-wrap">
                                        <rent-checkbox  ref="notEmpty" v-model="filter.status" val="5" checkboxMsg="已租無待辦" tickColor="black" bgColor="#fff" borderColor="#848b88"  :setDefault="isDefault"></rent-checkbox>
                                        <span>{{statusCount(5)}}</span>
                                    </div>
                                    <!-- <div class="check-box-wrap">
                                        <rent-checkbox  ref="tanantConfirm" v-model="filter.status" val="1" checkboxMsg="待租客確認" tickColor="white" bgColor="#3942b5" borderColor="#3942b5" :setDefault="isDefault"></rent-checkbox>
                                        <span>{{statusCount(1)}}</span>
                                    </div> -->
                                    <div class="check-box-wrap">
                                        <rent-checkbox  ref="arrears" v-model="filter.status" val="2" checkboxMsg="欠款" tickColor="white" bgColor="#fc7171" borderColor="#fc7171"  :setDefault="isDefault"></rent-checkbox>
                                        <span>{{statusCount(2)}}</span>
                                    </div>
                                    <div class="check-box-wrap">
                                        <rent-checkbox  ref="expiring" v-model="filter.status" val="3" checkboxMsg="快到期" tickColor="white" bgColor="#676362" borderColor="#676362"  :setDefault="isDefault"></rent-checkbox>
                                        <span>{{statusCount(3)}}</span>
                                    </div>
                                    <div class="check-box-wrap">
                                        <rent-checkbox  ref="rent" v-model="filter.status" val="4" checkboxMsg="收款提醒" tickColor="white" bgColor="#fcb773" borderColor="#fcb773"  :setDefault="isDefault"></rent-checkbox>
                                        <span>{{statusCount(4)}}</span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="house-status-default-filter-location">
                        <span class="title">地點</span>
                        <div class="group">
                            <rent-select class="select-scroll" refName="county" :selectMsg="address.county.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                                <ul>
                                    <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                                        {{county}}
                                    </li>
                                </ul>
                            </rent-select>
                            <rent-select class="select-scroll" refName="district" :selectMsg="address.district.msg" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="address.district.state">
                                <ul v-if="filter.countyId">
                                    <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                                        {{district.districtName}}
                                    </li>
                                </ul>
                            </rent-select>
                        </div>
                    </div>
                    <div class="house-status-default-filter-lease-term">
                        <span class="title">租期</span>
                        <date-picker :class="{'active': filter.leaseTerm[0] != null}" v-model="filter.leaseTerm" placeholder="2020.05.06-2020.05.06" format="YYYY.MM.DD" rangeSeparator="-" range  ></date-picker>
                    </div>
                    <div class="house-status-default-filter-lease-type">
                        <span class="title">出租類型</span>
                        <rent-select refName="houseType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                            <ul>
                                <li data-id="1">
                                    整層住家
                                </li>
                                <li data-id="2">
                                    套房
                                </li>
                                <li data-id="3">
                                    雅房
                                </li>
                                <!-- <li data-id="3">
                                    其他
                                </li> -->
                            </ul>
                        </rent-select>
                    </div>
                    <div class="house-status-default-filter-house-type">
                        <span class="title">房屋類型</span>
                        <rent-select refName="buildingType" selectMsg="所有類型" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                            <ul>
                                <li data-id="1">
                                    公寓
                                </li>
                                <li data-id="2">
                                    電梯大樓
                                </li>
                                <li data-id="3">
                                    透天
                                </li>
                                <li data-id="4">
                                    別墅
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                    <div class="house-status-default-filter-house-rent">
                        <span class="title">房屋金額</span>
                        <!-- <vue-range-slider ref="slider" height="2" :dotWidth="12" :dotHeight="12" :min="0" :max="100000" :enable-cross="true"  :formatter="formatter" v-model="filter.rent" :tooltip-merge="false"></vue-range-slider> -->
                        <vue-slider v-model="filter.rent" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
                    </div>
                    <!-- <div class="house-status-default-filter-house-country">
                        <span class="title">房屋國籍</span>
                        <rent-select refName="kk" selectMsg="所有國籍" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff">
                            <ul>
                                <li data-id="1">
                                    option1
                                </li>
                                <li data-id="2">
                                    option2
                                </li>
                                <li data-id="3">
                                    option3
                                </li>
                            </ul>
                        </rent-select>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/widge/RentSelect.vue';
import DropMenu from '@/components/widge/DropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import ContractType from '@/components/widge/ContractType.vue';
import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import BlockAmount from '@/components/landlord/houseStatus/BlockAmount.vue';
import TodoList from '@/components/landlord/houseStatus/TodoList.vue';
import DistrictHouse from '@/components/landlord/houseStatus/DistrictHouse.vue';
import SearchBar from '@/components/landlord/SearchBar.vue';
import UserMenu from '@/components/landlord/UserMenu.vue';
import MessageAlarm from '@/components/landlord/MessageAlarm.vue';
import TaskMenu from '@/components/landlord/houseStatus/TaskMenu.vue';
import newAllBill from '@/components/landlord/houseStatus/newAllBill.vue';
import DatePicker from 'vue2-datepicker';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'
import { apiGetCounty, apiGetDistrict} from "@/apis/api.js"; 

export default {
    name: 'HouseStatus',
    data () {
        return {
            filter: {
                country: '',
                county: '',
                countyId: '',
                district: '',
                empty: ['0','1'],
                // status: ['0','1','2','3','4'],
                status: ['0','1','2','3','4','5',],
                leaseTerm: [null, null],
                houseType: '',
                buildingType: '',
                rent: [0, 100000],
            },
            filterState: 0,
            filterIsFixed: false,
            managementList:[
                {
                    title: '房源管理',
                    link: '',
                    icon: require('@/assets/logo.png')
                },
                {
                    title: '帳單列表',
                    link: '',
                    icon: ''
                },
                {
                    title: '預定管理',
                    link: '',
                    icon: ''
                },
                {
                    title: '委託房客',
                    link: '',
                    icon: ''
                }
            ],
            taskMenu: false,
            taskHouseInfo: {},
            todoList: false,
            newContract: false,
            newContractLink: null,
            isDefault: false,
            address: {
                county: {
                    state: false,
                    msg: '所有縣市'
                },
                district: {
                    state: false,
                    msg: '所有區域'
                },
                road: {
                    state: false,
                    msg: '所有路段'
                }
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            componentKey: 0
            // time: null
        }
    },
    // metaInfo() {
    //     return {
    //         title: "房態首頁"
    //     };
    // },
    // metaInfo: {
    //     changed(metaInfo) {
    //         firebase.analytics().setCurrentScreen(metaInfo.title);
    //         firebase.analytics().logEvent("page_view");
    //         firebase.analytics().logEvent("screen_view", {
    //             app_name: "web",
    //             screen_name: metaInfo.title,
    //             app_version: version
    //         });
    //     }
    // },
    created () {
        this.$store.dispatch('getHouse')
        window.addEventListener('scroll', this.handleScroll);
    },
    mounted () {
        // this.$analytics.setCurrentScreen('房態首頁');
        // this.$analytics.logEvent("page_view");
        this.$analytics.logEvent("房態首頁", {
            screen_name: "房態首頁"
        });
    },
    destroyed () {
        this.setFilterDefault()
    },
    watch: {
        filter: {
            handler: function (newValue, oldValue) {
                this.$store.dispatch('setFilterHouse',this.filter)
                this.filterState = 1
            },
            deep: true
        },
    },
    methods: {
        getSelectId: function (value) {
            this.filterState = 1
            this.isDefault = false
            if( value.ref == 'county' ){
                this.address.district.state = true
                this.filter.district = null

                this.filter.county = value.name
                this.filter.countyId = value.id
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.address.district.state = false
                this.filter.district = value.name
            }else if( value.ref == 'houseType' ){
                this.filter.houseType = value.id
            }else if( value.ref == 'buildingType' ){
                this.filter.buildingType = value.id
            }
        },
        getHouse: function (value) {
            let allowStatus = this.$store.getters.DEFAULT_FILTER_STATUS
            let status = value.status.map( item => {
                if(allowStatus.includes(item)){
                    return item
                }
            })
            // console.log(status[0])
            // if(status[0] == undefined){
            //     this.taskMenu = false
            //     this.alart.success = true
            //     this.msg.success = '待辦事項已清空囉'
            // }else if(status.length > 0 || value.notRateTenant.length > 0){
                this.taskMenu = true
                this.taskHouseInfo = value
            // }
        },
        searchHouse: function (value) {
            this.$store.dispatch('searchHouse', value)
        },
        closeTaskMenu: function (value) {
            this.taskMenu = value
        },
        setFilterDefault: function () {
            this.filter.country = ''
            this.filter.county = ''
            this.filter.countyId = '0'
            this.filter.district = ''
            this.filter.empty = ['0','1']
            this.filter.status= ['0','1','2','3','4','5']
            this.filter.leaseTerm = []
            this.filter.houseType = ''
            this.filter.buildingType = ''
            this.filter.rent = [0, 100000]
            this.isDefault = true
            this.address.district.state = true
            setTimeout(()=>{
                this.filterState = 0
                this.isDefault = false
            },100)
        },
        closeModal: function (type) {
            if( type == 'todoList' ){
                this.todoList = false
            }else if( type == 'newContract' ){
                this.newContract = false
            }
        },
        handleScroll: function () {
            // console.log(event.path[1].scrollY)
            if( event.path[1].scrollY >= 178){
                this.filterIsFixed = true
            }else{
                this.filterIsFixed = false
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        contractLink: function (val) {
            this.newContractLink = val
            // this.$analytics.logEvent('新增紙本合約', { screen_name: '新增紙本合約'})
        },
        removeEmpty: function (val) {
            this.filter.empty.map((item, index) => {
                if(item == val){
                    this.filter.empty.splice(index, 1)
                }
            })
        },
        pushEmpty: function (val) {
            let isHas = false
            this.filter.empty.map((item, index) => {
                if(item == val){
                    isHas = true
                }
            })
            if(!isHas){
                this.filter.empty.push(val)
            }
        },
        removeStatus: function (val) {
            this.filter.status.map((item, index) => {
                if(item == val){
                    this.filter.status.splice(index, 1)
                }
            })
        },
        pushStatus: function (val) {
            let isHas = false
            this.filter.status.map((item, index) => {
                if(item == val){
                    isHas = true
                }
            })
            if(!isHas){
                this.filter.status.push(val)
            }
        },
        newAllBill: function () {
            this.$store.dispatch('sendEventLog', 'CREATE_BILL')
            this.$analytics.logEvent('新增費用_可選房源', { screen_name: '新增費用_可選房源'})
            this.$store.dispatch('setModalStatus', {state: true, type: 'newAllBill'})
        },
        statusCount: function (status) {
            let count = 0
            this.fileterByDistrict.map(houseList => {
                houseList.houseList.map(house => {
                    if(house.status.includes(status)){
                        count += 1
                    }
                })
            })
            return count
        }
    },
    computed: {
        fileterByCounty: function () {
            return this.houseResult.filter((houseItem) => {
                // console.log(this.filterQuery.county)
                if(this.filterQuery.county){
                    if(houseItem.county.includes(this.filterQuery.county) == true){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        fileterByDistrict: function () {
            return this.fileterByCounty.filter((houseItem) => {
                // console.log(houseItem)
                if( this.filterQuery.district){
                    if(houseItem.district.includes(this.filterQuery.district) == true){
                        return houseItem
                    }
                }else{
                    return houseItem
                }
            });
        },
        ...mapGetters({
            filterQuery: 'FILTER_QUERY',
            houseResult: 'HOUSE_RESULT',
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            roadResult: 'ROAD_RESULT',
            houseIsLoading: 'HOUSE_STATUS_LOADING'
        })
    },
    components: {
        RentSelect,
        RentCheckbox,
        BlockAmount,
        DistrictHouse,
        SearchBar,
        UserMenu,
        MessageAlarm,
        TaskMenu,
        DropMenu,
        DatePicker,
        Modal,
        TodoList,
        VueSlider,
        ContractType,
        newAllBill,
        AlartMsg
    }
}
</script>
<style lang="scss" scoped>
    .house-status-default{
        .amount-bar{
            display: flex;
            margin-bottom: 40px;
            >div{
                margin-right: 25px;
            }
        }
        .new-contract{
            .modal-content{
                width: 520px;
                height: 437px;
                padding: 0 !important;
                .detail{
                    align-items: unset !important;
                    h1{
                        margin-top: 36px;
                        margin-bottom: 40px;
                        margin-left: 32px;
                    }
                    .content{
                        padding: 0 32px 10px 32px;
                        height: 182px;
                        margin-bottom: 52px;
                    }
                    .content::-webkit-scrollbar {
                        display: none;
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                        button:first-child{
                            margin-right: 14px;
                        }
                    }
                }
                
            }
        }
        .house-status-default-wrap{
            display: flex;
            .house-status-default-wrap-left{
                position: relative;
                width: 859px;
                margin-right: 25px;
                .house-status-default-wrap-left-head{
                    margin-bottom: 25px;
                    height: 44px;
                    .title{
                        font-size: 28px;
                        font-weight: 500;
                        color: #292625;
                    }
                    .group-right{
                        position: absolute;
                        display: flex;
                        top: 0px;
                        right: 0px;
                        .drop-menu{
                            padding: 12px 14px 12px 24px;
                            height: 18px;
                            span{
                                font-weight: 500;
                            }
                            ul{
                                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                                width: 187px;
                                right: 0px;
                                li{
                                    // padding: 12px 16px;
                                    img{
                                        width: 20px;
                                        height: 20px;
                                        // background-color: #f0f0f0;
                                        margin-right: 15px;
                                    }
                                }
                            }
                        }
                        // .drop-menu:nth-child(1){
                        //     height: 18px;
                        //     margin-right: 16px;
                        //     span{
                        //         font-weight: 500;
                        //         color: #ff9275;
                        //     }
                           
                        // }
                        .drop-menu:nth-child(1){
                            height: 18px;
                            span{
                                font-weight: 500;
                                color: #fff;
                            }
                        }
                    }
                }
            }
            .house-status-default-wrap-right{
                position: relative;
                width: 270px;
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 24px;
                    right: 17px;
                }
                .house-status-default-filter::-webkit-scrollbar{
                    display: none;
                }
                .house-status-default-filter{
                    position: relative;
                    width: 270px;
                    background: #fff;
                    border-radius: 8px;
                    border: solid 1px #f0f0f0;
                    padding: 20px 0px 25px 0px;
                    .title{
                        display: block;
                        font-size: 16px;
                        margin-bottom: 16px;
                    }
                    .house-status-default-filter-title,
                    .house-status-default-filter-todo-list,
                    .house-status-default-filter-location,
                    .house-status-default-filter-lease-term,
                    .house-status-default-filter-lease-type,
                    .house-status-default-filter-house-type,
                    .house-status-default-filter-house-country,
                    .house-status-default-filter-house-rent{
                        padding: 0 20px 20px 20px;
                        border-bottom:2px solid #f6f6f6 ;
                    }
                    .house-status-default-filter-title{
                        span:nth-child(1){
                            display: flex;
                            align-items: center;
                            color: #a8a5a4;
                            img{
                                margin-right: 8px;
                            }
                        }
                    }
                    .house-status-default-filter-todo-list{
                        padding-top: 20px;
                        padding-bottom: 0px;
                        .todo-button{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 300;
                            width: 230px;
                            height: 44px;
                            color: #676362;
                            border-radius: 4px;
                            background-color: #f6f6f6;
                            margin-bottom: 20px;
                            cursor: pointer;
                        }
                        .todo-state{
                            .todo-state-wrap{
                                .todo-state-wrap-empty{
                                    display: flex;
                                    flex-direction: column;
                                    >div{
                                        margin-bottom: 17px;
                                    }
                                }
                                .todo-state-wrap-rented{
                                    display: flex;
                                    flex-direction: column;
                                    >div{
                                        margin-bottom: 17px;
                                    }
                                }
                                .check-box-wrap{
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    span{
                                        color: #a8a5a4;
                                    }
                                }
                            }
                        }
                    }
                    .house-status-default-filter-location{
                        padding-top: 20px;
                        .group{
                            display: flex;
                            .rent-select:nth-child(1){
                                margin-right: 10px;
                            }
                            .rent-select{
                                width: 83px;
                                height: 18px;
                            }
                        }
                        
                    }
                    .house-status-default-filter-lease-term,
                    .house-status-default-filter-lease-type,
                    .house-status-default-filter-house-type,
                    .house-status-default-filter-house-country{
                        padding-top: 20px;
                        .rent-select{
                            padding: 13px 16px;
                            height: 18px;
                        }
                    }
                    .house-status-default-filter-lease-term{
                        .mx-datepicker-range {
                            width: 228px;
                            input{
                                height: 46px;
                                border-radius: 4px;
                                border: solid 1px #e0dfde;
                                color: #a8a5a4;
                                padding: 13px 16px;
                                box-shadow: none;
                            }
                            .mx-icon-calendar,
                            .mx-icon-clear{
                                right: 18px;
                            }
                        }
                        .mx-datepicker-range:hover,
                        .mx-datepicker-range.active{
                            input{
                                border: 1px solid #676362 !important;
                                color: #676362 !important;
                            }
                            i{
                                color: #676362;
                            }
                        }
                    }
                    .house-status-default-filter-house-rent{
                        padding-top: 20px;
                        padding-bottom: 40px;
                        .title{
                            margin-bottom: 20px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .house-status-default{
            .house-status-default-wrap{
                .house-status-default-wrap-right{
                    width: 259px;
                    .house-status-default-filter{
                        // top: 24px;
                        width: 259px;
                        height: 527px;
                        overflow-x: hidden;
                        .house-status-default-filter-todo-list{
                            .todo-button{
                                width: 219px;
                            }
                            .todo-state{
                                .todo-state-wrap{
                                    .todo-state-wrap-empty{
                                        .todo-state-wrap-empty-left{
                                            margin-right: 60px;
                                        }
                                    }
                                    .todo-state-wrap-rented{
                                        .todo-state-wrap-rented-left{
                                            margin-right: 60px;
                                        }
                                    }
                                }
                            }
                        }
                        .house-status-default-filter-lease-term{
                            .mx-datepicker-range {
                                width: 219px;
                            }
                        }
                    }
                    .house-status-default-filter.fixed{
                        position: fixed;
                        top: 24px;
                    }
                }
            }
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseStatusSubPages/HouseStatusDefault.vue